import { render, staticRenderFns } from "./OfferCredit.vue?vue&type=template&id=5b990485&scoped=true&"
import script from "./OfferCredit.vue?vue&type=script&lang=js&"
export * from "./OfferCredit.vue?vue&type=script&lang=js&"
import style0 from "./OfferCredit.vue?vue&type=style&index=0&id=5b990485&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b990485",
  null
  
)

export default component.exports